import React, { useEffect, useState } from 'react';
import { getUrl, sendLinkHit } from 'redux/thunks/dashboard';
import { useDispatch, useSelector } from 'react-redux';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import NotificationsIcon from '@material-ui/icons/Notifications';
import PublicIcon from '@material-ui/icons/Public';
import { TrackLinkClick } from 'utilities/insights';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import { resetGettingUrl } from 'redux/actions/dashboard';

const useStyles = makeStyles({
    root: {
        justifyContent: 'flex-end',
    },
    paper: {
        backgroundColor: '#f8f8f8',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'lightgray'
        },
    },
});

const LinkCard = (props) => {
    const { link, siteId, dashboardId, userName, email, canEdit, onIconClick } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const dashboard = useSelector((state) => state.dashboard);
    const [linkClicked, setLinkClicked] = useState(false);

    const openLink = async (event) => {
        // APP INSIGHTS: Track link clicks per site
        TrackLinkClick(siteId, dashboardId, dashboard.selectedDashboard.name, userName, link.description, email);
        dispatch(sendLinkHit(siteId, dashboardId, link.linkId));
        setLinkClicked(true);
        dispatch(getUrl(siteId, dashboardId, link.linkId));
    };

    useEffect(() => {
        if (dashboard.gettingUrlSuccess && linkClicked) {
            const openWindow = window.open(dashboard.url);

            if (!openWindow) {
                window.location.href = dashboard.url;
            }

            setLinkClicked(false);
            dispatch(resetGettingUrl());
        }
    }, [dashboard.gettingUrlSuccess, linkClicked, dispatch, dashboard.url]);

    return (
        <>
            <Card classes={{ root: classes.paper }} onClick={openLink}>
                <CardHeader
                    action={
                        !link.isInternal && (
                            <IconButton disabled disableFocusRipple disableRipple aria-label='settings'>
                                <PublicIcon className='link-card-icon-external' />
                            </IconButton>
                        )
                    }
                    title={link.description}
                />
                <CardContent>
                    <Typography variant='body2' component='p'>
                        {link.category}
                    </Typography>
                </CardContent>
                <CardActions disableSpacing classes={{ root: classes.root }}>
                    {canEdit ? (
                        <IconButton onClick={onIconClick}>
                            <EditIcon />
                        </IconButton>
                    ) : (
                        <IconButton onClick={onIconClick}>
                            <NotificationsIcon />
                        </IconButton>
                    )}
                </CardActions>
            </Card>
        </>
    );
};

export default LinkCard;
